function downloadFile({ fileName, data, type = 'text/plain' }) {
  var blob = new Blob([data], { type });
  // text = 'data:application/vnd.ms-excel;charset=utf-8,' + text
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    var e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
    a.download = fileName;
    // a.href = text//window.URL.createObjectURL(blob);
    if (type === 'application/pdf') {
      a.href = window.URL.createObjectURL(blob);
    } else {
      const csvString = data;
      const universalBOM = '\uFEFF';
      a.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString);
    }
    a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  }

  return Promise.resolve();
}

function sanitize(text) {
  return text.replace(/(?!\p{L})./gu, '_'); // remove everything except unicode letters and underscores
}

function sanitizeExceptLetterAndNumber(text) {
  return text.replace(/(?!(\p{L}|\p{N}))./gu, '_');
}

function formatCell(x) {
  return x ? ('' + x + '').replace(/"/g, '').replace(/,/g, ' ') : '';
}
function tableToCsv({ table, dimensions, metricNames, translator, leafOnly }) {
  if (!translator) translator = x => x;
  const dimensionTitles = dimensions.map(x => (typeof x == 'object' ? formatCell(x.name) : x));
  const dimensionToGetIndex = dimensions.map(x => (typeof x == 'object' ? x.id : x));
  let csvRows = [[...dimensionTitles, ...metricNames].map(x => formatCell(translator(x))).join(', ')];

  let memorizedDimensionDatas = {
    index: 0,
    names: new Array(dimensions.length).fill(''),
  };
  for (let row of table) {
    setArrayToCsv(row, csvRows, metricNames, dimensionToGetIndex, memorizedDimensionDatas, leafOnly);
  }
  let csvText = csvRows.join('\n');
  return csvText;
}

function getDimensionNames(row, memorizedDimensionDatas, dimensions) {
  const { index } = memorizedDimensionDatas;
  const { dimension, name } = row;
  const thisDimensionIndex = dimensions.map(String).indexOf(String(dimension.id));
  if (index > thisDimensionIndex) {
    memorizedDimensionDatas.names.fill('', thisDimensionIndex + 1);
  }
  memorizedDimensionDatas.names[thisDimensionIndex] = formatCell(
    name || row.creative?.params?.descriptions?.[0] || `No Name`,
  );
  memorizedDimensionDatas.index = thisDimensionIndex;
  return [...memorizedDimensionDatas.names];
}
function setArrayToCsv(row, csvRows, metricNames, dimensions, memorizedDimensionDatas, leafOnly) {
  let csvRow = [
    ...getDimensionNames(row, memorizedDimensionDatas, dimensions),
    // ...getDimensionNames(row, dimensions, formatCell),
    ...metricNames.map(metricName => {
      let metricValue = row.cell[metricName];

      if (typeof metricValue === 'object') {
        if (Array.isArray(metricValue)) {
          //if array
          if (metricValue.every(v => typeof v === 'string')) {
            // elements are all string
            metricValue = formatCell(metricValue.join(' / '));
          } else {
            metricValue = '';
          }
        } else {
          //if object
          switch (metricName) {
            // if metricName is budget, it have to check daily or total
            case 'budget':
              {
                const { daily, lifeTime } = metricValue;

                if (daily && lifeTime) {
                  metricValue = daily + '/d' + ' | ' + lifeTime + ' tot.';
                } else if (daily) {
                  // metricNames = numeral(Number(value)).format('0,0') + '/d';
                  metricValue = daily + '/d';
                } else if (lifeTime) {
                  // metricNames = numeral(Number(value)).format('0,0') + ' tot.';
                  metricValue = lifeTime + ' tot.';
                } else {
                  metricValue = '';
                }
              }
              break;
            default: {
              metricValue = '';
            }
          }
        }
      } else {
        // if string
        metricValue = formatCell(metricValue);
      }
      return metricValue;
    }),
  ];
  if (!leafOnly || !row.children || !row.children.length) {
    csvRows.push(csvRow.map(x => `"${x}"`).join(','));
  }
  if (row.children) {
    for (let childrenRow of row.children) {
      setArrayToCsv(childrenRow, csvRows, metricNames, dimensions, memorizedDimensionDatas, leafOnly);
    }
  }
}

function triggerTableDownload({ table, dimensions, metricNames, translator, widgetTitle, leafOnly }) {
  widgetTitle = widgetTitle ? widgetTitle : 'table';
  let csvText = tableToCsv({ table, dimensions, metricNames, translator, leafOnly });
  downloadFile({
    fileName: widgetTitle + '.csv',
    data: csvText,
    type: 'text/csv',
  });
}

// Add a js script to the current document
function injectScript(scriptUrl) {
  return new Promise(resolve => {
    let script = document.createElement('script');
    script.src = scriptUrl;
    script.async = false;
    script.defer = false;
    script.addEventListener('load', function () {
      resolve();
    });
    document.head.appendChild(script);
  });
}

// Take a png screenshot of a widget
async function widget2image(widgetElement) {
  if (window.domtoimage == undefined)
    await injectScript('https://unpkg.com/dom-to-image@latest/dist/dom-to-image.min.js');
  let image = await window.domtoimage.toPng(widgetElement);
  return image;
}

// Convert a widget to pdf
async function widget2pdf(widgetElement) {
  if (window.jspdf == undefined) await injectScript('https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js');
  let { width, height } = widgetElement.getBoundingClientRect();
  let image = await widget2image(widgetElement);
  var doc = new window.jspdf.jsPDF();
  let zoom = 210 / width;
  doc.addImage(image, 'PNG', 0, 0, width * zoom, height * zoom);
  return doc.output('arraybuffer');
}

async function triggerWidgetPdfDownload({ widgetElement, widgetTitle }) {
  let pdf = await widget2pdf(widgetElement);
  return downloadFile({
    fileName: sanitizeExceptLetterAndNumber(widgetTitle) + '.pdf',
    data: pdf,
    type: 'application/pdf',
  });
}

// Find where each widget start and finish within a canvas containing the screenshot of the dashboard.
function findWidgetBoundsInImage({ context, width, height }) {
  let imgData = context.getImageData(0, 0, width, height).data;
  let widgetBounds = [];
  let widgetTop = 0;
  for (let y = 0; y < height; y++) {
    let allRowPixelsAreTransparent = true;
    for (let x = 0; x < width; x++) {
      if (imgData[4 * (width * y + x) + 3] != 0) {
        allRowPixelsAreTransparent = false;
        break;
      }
    }
    if (allRowPixelsAreTransparent) {
      if (y > widgetTop) {
        widgetBounds.push([widgetTop, y - 1]);
      }
      widgetTop = y + 1;
    }
  }
  if (widgetTop < height - 1) {
    widgetBounds.push([widgetTop, height - 1]);
  }
  return widgetBounds;
}

async function dashboard2pdf({ el, name }) {
  const marginBetweenWidgets = 10;
  const pagePadding = 20;
  const pageHeight = 270;
  const pageWidth = 219;

  if (window.domtoimage == undefined)
    await injectScript('https://unpkg.com/dom-to-image@latest/dist/dom-to-image.min.js');
  let imBlob = await domtoimage.toBlob(el);
  let { context, width, height } = await _convertBlobToCanvas(imBlob);
  let widgetBounds = findWidgetBoundsInImage({ context, width, height });
  if (window.jspdf == undefined) await injectScript('https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js');
  var doc = new window.jspdf.jsPDF();
  let currentPage = doc;
  let currentPos = pagePadding;
  let zoom = (pageWidth - 2 * pagePadding) / width;
  for (let widgetBound of widgetBounds) {
    await addWidgetImageToPdf(widgetBound);
  }
  async function addWidgetImageToPdf([top, bottom]) {
    if (
      currentPos + marginBetweenWidgets + (bottom - top + 1) * zoom > pageHeight - pagePadding &&
      top > pagePadding + 1
    ) {
      currentPage = doc.addPage();
      currentPos = pagePadding;
    }
    let widgetImageData = context.getImageData(0, top, width, bottom - top + 1);
    let widgetImageBlob = await _imageDataToBlob(widgetImageData);
    let widgetImageURL = URL.createObjectURL(widgetImageBlob);
    currentPage.addImage(
      widgetImageURL,
      'PNG',
      pagePadding,
      currentPos + marginBetweenWidgets,
      width * zoom,
      (bottom - top + 1) * zoom,
    );
    currentPos += marginBetweenWidgets + (bottom - top + 1) * zoom;
  }
  return downloadFile({
    fileName: name || 'dashboard.pdf',
    data: doc.output('arraybuffer'),
    type: 'application/pdf',
  });
}

async function triggerDashboardPdfDownload({ el, name = 'dashboard.pdf' }) {
  return dashboard2pdf({ el, name });
}

function createFileFromTable(arg) {
  const { table, dimensions, metricNames, translator, widgetTitle = 'table', type = 'text/plain', leafOnly } = arg;
  const csvText = tableToCsv({ table, dimensions, metricNames, translator, leafOnly });
  const blob = new Blob([`\uFEFF${csvText}`], { type });
  const file = new File([blob], widgetTitle, { type });
  return Promise.resolve(file);
}

function getDimensionNamesRaw(row, memorized, dimensions) {
  const { index } = memorized;
  const { dimension, name } = row;
  const thisDimensionIndex = dimensions.map(String).indexOf(String(dimension.id));
  if (index > thisDimensionIndex) {
    memorized.names.fill('', thisDimensionIndex + 1);
  }
  memorized.names[thisDimensionIndex] = name || row.creative?.params?.descriptions?.[0] || 'No Name';
  memorized.index = thisDimensionIndex;
  return [...memorized.names];
}

function setArrayToAoa(row, rows, metricNames, dimensions, memorized, leafOnly) {
  const dataRow = [
    ...getDimensionNamesRaw(row, memorized, dimensions),
    ...metricNames.map(metricName => {
      let metricValue = row.cell[metricName];

      if (typeof metricValue === 'number') {
        return metricValue;
      }

      if (typeof metricValue === 'object' && metricValue !== null) {
        if (Array.isArray(metricValue)) {
          if (metricValue.every(v => typeof v === 'string')) {
            return metricValue.join(' / ');
          }
          return '';
        }
        if (metricName === 'budget') {
          const { daily, lifeTime } = metricValue;
          if (daily && lifeTime) return daily + '/d' + ' | ' + lifeTime + ' tot.';
          if (daily) return daily + '/d';
          if (lifeTime) return lifeTime + ' tot.';
          return '';
        }
        return '';
      }

      if (metricValue === null || metricValue === undefined) return '';

      return '' + metricValue;
    }),
  ];

  if (!leafOnly || !row.children || !row.children.length) {
    rows.push(dataRow);
  }

  if (row.children) {
    for (const childRow of row.children) {
      setArrayToAoa(childRow, rows, metricNames, dimensions, memorized, leafOnly);
    }
  }
}

function tableToAoa({ table, dimensions, metricNames, translator, leafOnly }) {
  if (!translator) translator = x => x;
  const dimensionTitles = dimensions.map(x => (typeof x === 'object' ? x.name : x));
  const dimensionToGetIndex = dimensions.map(x => (typeof x === 'object' ? x.id : x));
  const rows = [];
  rows.push([...dimensionTitles, ...metricNames].map(x => translator(x)));

  const memorized = { index: 0, names: new Array(dimensions.length).fill('') };
  for (const row of table) {
    setArrayToAoa(row, rows, metricNames, dimensionToGetIndex, memorized, leafOnly);
  }
  return rows;
}

async function createXlsxFile({
  table,
  dimensions,
  metricNames,
  translator,
  widgetTitle,
  leafOnly,
}) {
  if (window.XLSX == undefined) {
    await injectScript('https://unpkg.com/xlsx@latest/dist/xlsx.full.min.js');
  }
  const XLSX = window.XLSX;

  const aoa = tableToAoa({ table, dimensions, metricNames, translator, leafOnly });
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  const wb = XLSX.utils.book_new();

  let sheetName = (widgetTitle || '').replace(/[\\/?*\[\]]/g, '_').slice(0, 31);
  if (!sheetName) sheetName = 'Sheet1';
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  const arrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const fileName = (widgetTitle || 'table') + '.xlsx';
  const type =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([arrayBuffer], { type });
  return new File([blob], fileName, { type });
}

module.exports = {
  triggerTableDownload,
  tableToCsv,
  triggerWidgetPdfDownload,
  triggerDashboardPdfDownload,
  createFileFromTable,
  tableToAoa,
  createXlsxFile,
};

async function _convertBlobToCanvas(imBlob) {
  let imBlobUrl = URL.createObjectURL(imBlob);
  let img = new Image();
  img.src = imBlobUrl;
  await new Promise(resolve => {
    img.onload = () => {
      resolve();
    };
  });
  let canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  let context = canvas.getContext('2d');
  context.drawImage(img, 0, 0, img.width, img.height);
  return { canvas, context, width: img.width, height: img.height };
}

async function _imageDataToBlob(imageData) {
  let w = imageData.width;
  let h = imageData.height;
  let canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  let ctx = canvas.getContext('2d');
  ctx.putImageData(imageData, 0, 0);
  let blob = await new Promise(resolve => canvas.toBlob(resolve));
  canvas.remove();
  return blob;
}
